import { UPDATE_ME } from '../types'

const state = {
  me: null,
}

const getters = {
  isLogin: (state) => {
    return state.me && state.me.id
  },
  uc: (state) => {
    return state.me
  },
  isSuper: (state) => {
    return state.me && state.me.super
  },
}

const mutations = {
  [UPDATE_ME](state, me) {
    state.me = me
  },
}

export default {
  state,
  getters,
  mutations,
}
